import axios from 'axios';
import headers from "./Header";

let url = 'api/wilayah'
class WilayahService {
    getProvinsi() {
        return axios.get(url + '/provinsi', {
            headers: headers(),
        })
    }

    getKabupatenKotaByIdProvinsi(id) {
        return axios.get(url + '/kabupatenkota/' + id, {
            headers: headers(),
        })
    }

    getKabupatenKotaByKodeProvinsi(kode) {
        return axios.get(url + '/kabupatenkotakode/' + kode, {
            headers: headers(),
        })
    }

    getRegions(params) {
        if (params != '') {
            return axios.get(url + '/regions' + params, {
                headers: headers(),
            })
        } else {
            return axios.get(url + '/regions', {
                headers: headers(),
            })
        }
    }
}

export default new WilayahService();